import {
  all, put, takeEvery, select,
} from 'redux-saga/effects';
import {
  change, doSubmit, startSubmit, stopSubmit, reset,
} from 'circe/forms/actions';
import { exception } from 'circe/logger';
import { onboardingClient } from 'domain/HttpClients';
import { formatRequest } from 'domain/vehicle/components/create/utils';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import { FORM_NAME } from './constants';

function* doCreateVehicle(context, action) {
  if (action.payload.name !== FORM_NAME) return;

  yield put(startSubmit(FORM_NAME));

  try {
    const {
      payload: { values },
    } = action;

    yield registerVehicleInformation(values);

    yield put(reset(FORM_NAME));
    yield put(
      showNotification(
        I18n.str('vehicleCreatedSuccessfully', 'Vehicle Created Successfully'),
        'success',
      ),
    );
    setTimeout(() => {
      context.history.push('/vehicles');
    }, 2000);
  } catch (e) {
    yield put(
      showNotification(I18n.str('error', 'Something Went Wrong, Please try again'), 'error'),
    );
    console.error(e);
  } finally {
    yield put(stopSubmit(FORM_NAME));
  }
}

function* registerVehicleInformation(values) {
  const { truckDetails } = values;
  const state = yield select();
  const token = state.circe.authentication.tokens.idToken;
  const data = formatRequest(truckDetails);
  try {
    const response = yield onboardingClient
      .Post(`api/vehicles${truckDetails.driverId ? `/${truckDetails.driverId}` : ''}`)
      .withHeaders({ Authorization: `Bearer ${token}`, 'Content-type': 'application/json' })
      .withData(data)
      .send();
  } catch (e) {
    console.error(e);
    throw new Error(e.message);
  }
}

function* watcher(context) {
  yield all([takeEvery(doSubmit().type, doCreateVehicle, context)]);
}

export default watcher;
